import React, { useMemo } from 'react'
import './SalesAlert.scss'
import { ReactComponent as CloseIcon } from '../../components/assets/images/CloseModalIcon.svg'
import { ReactComponent as TPOLogoNew } from '../../components/assets/images/TPOLogoNew.svg'
import { mainApi } from '../../../store/services/mainApi'
import { useParams } from 'react-router'
import { useDispatch, useSelector } from 'react-redux'
import { setAllItemsCart, setItemsCart } from '../../../store/slices/allItemsCart'

const SalesAlert = ({ closeFunc }) => {
  const { data: sales, isLoading, isError } = mainApi.useGetSalesQuery()
  
  const sale = useMemo(() => {
    const sale = sales?.find((el) => el?.isActive)
    return sale ? sale : null
  }, [sales])

  console.log(sale);

  const tradeName = location.pathname.replace('/category/', '').replace('/newOrder/', '')
  console.log(tradeName)

  const allItemsCart = useSelector((state) => state.allItemsCart.allItemsCart);
  console.log(allItemsCart)
  const dispatch = useDispatch()

  const currentSale = useMemo(() => {
    if (!isLoading) {
      return sales?.find((el) => el?.isActive)
    }
  }, [sales, isLoading])

  return (currentSale?.excludedBusinesses?.includes(tradeName)  ?
    <div
      className='SalesAlert'
      onClick={() => closeFunc(false)}
    >
      <div className='SalesAlert__modal' onClick={(e) => e.stopPropagation()}>
        <div className='SalesAlert__modal__header'>
          <div className='SalesAlert__modal__header__label'>
            <TPOLogoNew height={'31px'}/>
            Tu Producto Online
          </div>
          <CloseIcon width={'15px'} height={'15px'} onClick={async () => {
            closeFunc(false)
          }}/>
        </div>
        <div className='SalesAlert__modal__preview'>
          <img src={currentSale?.imgLink} alt={sale?.img} />
        </div>
        <div className='SalesAlert__modal__info'>
          <h1>{currentSale?.name}</h1>
          <p>{currentSale?.description}</p>
        </div>
        <div className='SalesAlert__modal__list'>
          {currentSale?.products?.length > 0 && 
          currentSale?.products?.map((sale, index) => {
            const inCart = allItemsCart.find((el) => el?.sku == sale.sku);
            return <div
              key={index}
              className='SalesAlert__modal__list__item'
            >
              <p>
                {sale?.name ? sale.name : 'Name not found'}
              </p>
              <div className='SalesAlert__modal__list__item__price'>
                {sale?.spoPrice == sale?.marketPriceCP || !sale?.spoPrice ?
                <h1>{sale?.marketPriceCP}</h1>
                : <><h1>{sale?.spoPrice}</h1>
                <h2 style={{ color: '#f58c8c80'}}>{sale?.marketPriceCP}</h2></>}
              </div>
              <button
                onClick={() => {
                  dispatch(setAllItemsCart(sale))
                }}
                style={inCart ? {
                  background: '#fff',
                  color: '#3bb77e',
                  border: '2px solid #3bb77e'
                } : {}}
              >
                {!inCart &&<svg width="19" height="18" viewBox="0 0 19 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <g clipPath="url(#clip0_2154_12651)">
                    <path d="M5.63094 16.0007C6.51442 16.0007 7.23063 15.1742 7.23063 14.1546C7.23063 13.1351 6.51442 12.3086 5.63094 12.3086C4.74745 12.3086 4.03125 13.1351 4.03125 14.1546C4.03125 15.1742 4.74745 16.0007 5.63094 16.0007Z" stroke="white" strokeMiterlimit="1.5" strokeLinecap="round" strokeLinejoin="round" />
                    <path d="M13.6309 16.0007C14.5144 16.0007 15.2306 15.1742 15.2306 14.1546C15.2306 13.1351 14.5144 12.3086 13.6309 12.3086C12.7474 12.3086 12.0312 13.1351 12.0312 14.1546C12.0312 15.1742 12.7474 16.0007 13.6309 16.0007Z" stroke="white" strokeMiterlimit="1.5" strokeLinecap="round" strokeLinejoin="round" />
                    <path d="M7.27018 14.1532H11.2294V4.55381C11.2294 4.24795 11.0146 4 10.7495 4H1.78125" stroke="white" strokeLinecap="round" />
                    <path d="M3.7524 14.1508H2.11272C1.84767 14.1508 1.63281 13.9029 1.63281 13.597V9.07422" stroke="white" strokeLinecap="round" />
                    <path d="M1.78125 6.30859H4.98063" stroke="white" strokeLinecap="round" strokeLinejoin="round" />
                    <path d="M11.2344 6.76562H15.7216C15.9112 6.76562 16.0831 6.89452 16.1601 7.09452L17.5918 10.8118C17.619 10.8827 17.6331 10.9593 17.6331 11.0367V13.596C17.6331 13.9018 17.4183 14.1498 17.1532 14.1498H15.6335" stroke="white" strokeLinecap="round" />
                    <path d="M11.2344 14.1562H12.0342" stroke="white" strokeLinecap="round" />
                  </g>
                  <defs>
                    <clipPath id="clip0_2154_12651">
                      <rect width="18" height="18" fill="white" transform="matrix(1 0 0 -1 0.5 18)" />
                    </clipPath>
                  </defs>
                </svg>}
                {inCart ? 'In cart' : 'Add'}
              </button>
            </div>}
          )}
        </div>
      </div>
    </div> : <></>
  )
}

export default SalesAlert